import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.003 21.607c.32.733.497 1.543.497 2.393a5.97 5.97 0 0 1-.593 2.6l11.475 6.269a6 6 0 1 1-.749 1.87l-11.892-6.496A5.982 5.982 0 0 1 11.5 30c-3.312 0-6-2.69-6-6 0-3.312 2.69-6 6-6 1.74 0 3.308.743 4.405 1.928l11.782-6.436A6.004 6.004 0 0 1 33.5 6c3.312 0 6 2.69 6 6 0 3.312-2.69 6-6 6a5.997 5.997 0 0 1-4.994-2.676l-11.503 6.283ZM7.5 24c0 2.206 1.793 4 4 4 2.206 0 4-1.793 4-4 0-2.206-1.793-4-4-4-2.206 0-4 1.793-4 4Zm22-12c0 2.206 1.793 4 4 4 2.206 0 4-1.793 4-4 0-2.206-1.793-4-4-4-2.206 0-4 1.793-4 4Zm0 24c0 2.206 1.793 4 4 4 2.206 0 4-1.793 4-4 0-2.206-1.793-4-4-4-2.206 0-4 1.793-4 4Z",
      clipRule: "evenodd"
    }
  )
);
var SvgShareOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ShareOutlined_default = SvgShareOutlined;

export { ShareOutlined_default as default };
